export default {
  brand: {
    primary: '#3C053C',
    secondary: '#F3BD31',
    tertiary: '#AF4B78',
    quaternary: '#F0F0F0',
  },
};
